import React, { Fragment, useState } from 'react';

// Material UI
import TablePagination from '@mui/material/TablePagination';

// Components
import Table from './index';
import { Spinner } from '@arredo/reactjs-ui';

const TableAndPagination = ({ rows, columns, loading, actions }) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    return (
        <>
            {
                loading
                    ? <Spinner message='Cargando' />
                    : <div>
                        <Table
                            page={page}
                            rows={rows}
                            columns={columns}
                            rowsPerPage={rowsPerPage}
                            actions={actions}
                        />

                        <TablePagination
                            count={rows.length}
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={(e, newPage) => setPage(newPage)}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </div>
            }
        </>
    );
}

export default TableAndPagination;